import { isNonProductionBuild } from './non-production-build';
import { toggleableStateKeptInSessionStorageFactory } from './toggleable-state-kept-in-session-storage-factory';

const LOCAL_BACKEND_IS_ACTIVE_STORAGE_KEY = 'local-backend-is-active';

export class LocalBackendState extends toggleableStateKeptInSessionStorageFactory(LOCAL_BACKEND_IS_ACTIVE_STORAGE_KEY) {

	// A flag set from DevTools must not point a production build at a backend on localhost
	static override get isActive(): boolean {
		return isNonProductionBuild() && super.isActive;
	}

}
